module.exports = __webpack_public_path__ + "static/media/certificatesidebarmenu.39296abb.png";